import React from "react";
import { Flex } from "../../assets/ui";
import {
  StyledInfo,
  StyledSectionWrapper,
  StyledIndicators,
  StyledDescription,
  StyledImageWrapper,
  PhonesImage
} from "./ui";

const TeachersTrainersCases = () => {
  return (
    <StyledSectionWrapper id="teacher_trainers">
      <Flex
        flexDirection={["column", "row", "row"]}
        alignItems={["center"]}
        position="relative"
        marginBottom={["0", "70px"]}
      >
        <StyledIndicators display={["flex", "none"]}>
          <h3>Sports & Activities</h3>
        </StyledIndicators>

        <StyledDescription>
          <h4>All your customers, bookings and money in one place</h4>
          <p>
            No more cancellations. Manage your calendar and bookings whilst
            protecting your earnings
          </p>
          <StyledInfo display={["none", "block"]}>
            Personal Trainers and teachers can use Exsportia’s technology to
            fully manage their careers.
          </StyledInfo>
        </StyledDescription>

        <StyledImageWrapper>
          <StyledIndicators display={["none", "flex"]}>
            <p>Teachers & Classes</p>
            <h3>Sports & Activities</h3>
            <p>Leagues & Tournaments</p>
          </StyledIndicators>
          <PhonesImage />
        </StyledImageWrapper>

        <StyledInfo display={["block", "none"]}>
          “Personal Trainers and teachers can now use Exsportia’s technology to
          fully manage their careers.”
        </StyledInfo>
      </Flex>
    </StyledSectionWrapper>
  );
};

export default TeachersTrainersCases;
